import { withTranslation } from 'react-i18next';
import EndedProcessInstanceTable from './EndedProcessInstanceTable';

export default withTranslation('pages')(EndedProcessInstanceTable);
